import React from 'react';
import { Badge } from './ui/badge';
import { ShieldCheck, ShieldAlert, ShieldX, ShieldQuestion } from 'lucide-react';

const STATUS_MAP = {
  valida: { label: 'Valida', cls: 'bg-emerald-100 text-emerald-700 border border-emerald-300', icon: ShieldCheck },
  in_scadenza: { label: 'In scadenza', cls: 'bg-amber-100 text-amber-800 border border-amber-300', icon: ShieldAlert },
  scaduta: { label: 'Scaduta', cls: 'bg-red-100 text-red-700 border border-red-300', icon: ShieldX },
  non_disponibile: { label: 'Mai tarato', cls: 'bg-slate-100 text-slate-600 border border-slate-300', icon: ShieldQuestion },
};

export default function CalibrationStatusBadge({ status, days, className = '' }) {
  const v = STATUS_MAP[status] || STATUS_MAP.non_disponibile;
  const Icon = v.icon;
  let suffix = '';
  if (status === 'in_scadenza' && typeof days === 'number') suffix = ` · ${days}gg`;
  if (status === 'scaduta' && typeof days === 'number') suffix = ` · ${Math.abs(days)}gg fa`;
  return (
    <Badge className={`${v.cls} px-2.5 py-1 inline-flex items-center gap-1.5 ${className}`} data-testid={`cal-status-${status}`}>
      <Icon className="w-3.5 h-3.5" />
      <span>{v.label}{suffix}</span>
    </Badge>
  );
}

export const CAL_STATUSES = [
  { value: 'valida', label: 'Valida' },
  { value: 'in_scadenza', label: 'In scadenza' },
  { value: 'scaduta', label: 'Scaduta' },
  { value: 'non_disponibile', label: 'Mai tarato' },
];

export const INSTRUMENT_TYPES = [
  { value: 'calibro', label: 'Calibro' },
  { value: 'calibro_digitale', label: 'Calibro digitale' },
  { value: 'micrometro', label: 'Micrometro' },
  { value: 'comparatore', label: 'Comparatore' },
  { value: 'calibro_passa_non_passa', label: 'Calibro passa/non passa' },
  { value: 'rugosimetro', label: 'Rugosimetro' },
  { value: 'durometro', label: 'Durometro' },
  { value: 'dinamometro', label: 'Dinamometro' },
  { value: 'manometro', label: 'Manometro' },
  { value: 'altro', label: 'Altro' },
];
